const LabeledBooleanInput = ({
    label,
    value,
    trueLabel,
    falseLabel,
    name,
    state,
    onChange,
}) => {
    if (state) {
        value = state[name];
    }

    const handleChange = (e) => {
        const newEvent = {
            target: {
                name: e.target.name,
                value: e.target.checked,
            },
        };
        onChange(newEvent);
    };

    const selectedStyle = {
        backgroundColor: "yellow",
    };

    const unselectedStyle = {
        textDecoration: "line-through",
    };

    return (
        <div className={"form-input-area__input"}>
            <label>
                <span style={!value ? selectedStyle : unselectedStyle}>
                    {falseLabel}
                </span>
                <input
                    type="checkbox"
                    name={name}
                    checked={value}
                    onChange={handleChange}
                />
                <span style={value ? selectedStyle : unselectedStyle}>{trueLabel}</span>

                {label && <span> {label} </span>}
            </label>
        </div>
    );
};

export default LabeledBooleanInput;
